export class RegistrationBasicElement {


  //WareHouseId:number;
ItemId1:number;    ItemId2:number;    ItemId3:number;

AdmissionFamilyBackgroundId:number;
AdmissionMasterCategoryId:number;
AdmissionMasterCategorySubId:number;

PrivilegeID:number;

CompId:number;
BranchId:number;

 AdmissionPersonalId:number;
 AdmissionMasterId:number;
 HowKnowUs:string;
 FullName:string;
 DOB:string;
 Age:string;
 SexId:number;
 ContactNo:string;
 Email:string;
 AdmissionDate:string;
 AdmissionTime:string;
 PersonIDCategoryId:number;
 IDNO:string;
 FamilyMembersCount:string;

 ReferralAdmissionMasterId:string;
 AdmissionStatus:string;
 
 Country_Id:number;
 State_Id:number;
 City_Id:number;
 PinCode:string;
 AreaId:number;
 ZoneId:number;
 TempAddress:string;
 PermanentAddress:string;
 ReligionId:number;
 MaritalStatusId:number;
 BloodGroupId:number;
 Nationality:number;

  OperationType :string;
  CreatedBy :number;
  MachineIP :string;
  Notes:string;
  Code:string;

  }
